$(document).ready(function() {

// BANNER TOP SLIDER
var autoplay = 6000;

var banner_top_slider = new Swiper ('.banner-slider', {
  slidesPerView: 1,
  effect: 'fade',
  speed: 600,
  allowTouchMove: false,
  fadeEffect: {
    crossFade: true
  },
  autoplay: {
    delay: autoplay,
    stopOnLastSlide: false,
    disableOnInteraction: false
  },
  pagination: {
    el: '.banner-top-nav',
    type: 'fraction',
    renderFraction: function (currentClass, totalClass) {
      return '<span class="text-medium ' + currentClass + '"></span>' + ' <span class="line"><span id="progress"></span></span> ' + '<span class="text-medium ' + totalClass + '"></span>';
    }
  },
  on: {
    progress: move,
    slideChange: function () {
      $('#top-banner').removeClass('slide-01 slide-02 slide-03 slide-04');

      if(this.activeIndex === 0) {
        $('#top-banner').addClass('slide-01');
      } else if (this.activeIndex === 1) {
        $('#top-banner').addClass('slide-02');
      } else if (this.activeIndex === 2) {
        $('#top-banner').addClass('slide-03');
      } else if (this.activeIndex === 3) {
        $('#top-banner').addClass('slide-04');
      }
    }
  }
});

// BANNER TOP TIMER
function move() {
  if ($(window).width() > 992) {
    var height = 1;
    var autoplayTime = autoplay / 100;
    var id = setInterval(frame, autoplayTime);
    clearInterval(window.current_swipper_id);
    window.current_swipper_id = id;
    function frame() {
      if (height >= 100) {
        clearInterval(id);
      } else {
        height++;
        $('#progress').css('height', height + "%");
      }
    }
  } else {
    var width = 1;
    var autoplayTime = autoplay / 100;
    var id = setInterval(frame, autoplayTime);
    function frame() {
      if (width >= 100) {
        clearInterval(id);
      } else {
        width++;
        $('#progress').css('width', width + "%");
      }
    }
  }
}


// PRDUCTS NAV MOBILE
var prod_nav = new Swiper ('.prod-mobile-nav', {
  slidesPerView: 1,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  speed: 600,
  allowTouchMove: false,
  spaceBetween: 0,
  centeredSlides: true,
  slideToClickedSlide: true,
  navigation: {
    prevEl: '#prod-nav-arrows .prev',
    nextEl: '#prod-nav-arrows .next'
  },
});

// PRODUCTS MAIN SLIDER
var prod_categories = ['Pre-Workouts', 'Proteins', 'Strength & Endurance', 'Recovery', 'Support', 'Apparel', '']
var prod_slider = new Swiper ('.featured-prod-slider', {
  slidesPerView: 1.2,
  watchSlidesVisibility: true,
  allowTouchMove: false,
  watchSlidesProgress: true,
  speed: 600,
  pagination: {
    el: '.prod-nav',
    clickable: true,
    renderBullet: function (index, className) {
      return '<button class="' + className + '"><span class="text-medium hvr-bounce-to-right">' + (prod_categories[index]) + '</span></button>';
    },
  },
  breakpoints: {
    1200: {
      slidesPerView: 1,
    }
  }
});

// PRODUCTS DESCRIPTION SLIDER
var description_slider = new Swiper ('.prod-description-slider', {
  slidesPerView: 1,
  autoHeight: true,
  allowTouchMove: false,
  calculateHeight: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  watchSlidesVisibility: true,
  watchSlidesProgress: true
});

// INTEGRATE PRODUCT SLIDERS
prod_nav.controller.control = prod_slider;
prod_slider.controller.control = description_slider;

// REMOVE EMPTY SLIDER AT @QUERIE MD
if ($(window).width() < 992) {
  // $('.featured-prod-slider .last-slide').remove();
  // $('.prod-description-slider .last-slide').remove();
  description_slider.update();
  prod_slider.update();
};

$(window).resize(function() {
    description_slider.update();
    prod_slider.update();
});
});
